export class CryptoError extends Error {}
